import React from "react";
import classes from "./sortedByContainer.module.css";

const SortedByContainer = (props) => {
  const { currentSort } = props;

  return (
    <div className={classes.root} aria-live="polite" aria-busy="true">
      <span>Items sorted by</span>
      <span className={classes.sortText}>
        <span>{currentSort.sortText}</span>
      </span>
    </div>
  );
};

export default SortedByContainer;
